import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

const JoinGame = lazy(() => import("./pages/JoinGame"));
const GamePlay = lazy(() => import("./pages/GamePlay"));
const SpectatorView = lazy(() => import("./pages/SpectatorView"));

function Spinner() {
  return (
    <div className="min-h-screen bg-[#0a0a1a] flex items-center justify-center">
      <div className="w-8 h-8 rounded-full border-2 border-purple-600 border-t-transparent animate-spin" />
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="/join" element={<JoinGame />} />
        <Route path="/join/:pin" element={<JoinGame />} />
        <Route path="/game" element={<GamePlay />} />
        <Route path="/spectate/:pin" element={<SpectatorView />} />
        <Route path="*" element={<Navigate to="/join" replace />} />
      </Routes>
    </Suspense>
  );
}
